//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/index.css';
import MtInput from '~/components/form/MtInput'
import Dropdown from '~/components/form/Dropdown'
import MtModal from '~/components/Modal/MtModal'

export default {
  components: {
    MtModal,
    Dropdown,
    MtInput,
    DatePicker,
  },
  props: {
    myProfileData: {
      type: Object,
      default: () => {}
    }
  },
  data (){
    return {
      dropdown: {
        data: [
          {id: 0, name: this.$t('profileForm.sexOptionLabelNone'), value: null },
          {id: 1, name: this.$t('profileForm.sexOptionLabelMale'), value: 'M'},
          {id: 2, name: this.$t('profileForm.sexOptionLabelFemale'), value: 'F'}
        ],
        selected: {id: 0, name: this.$t('profileForm.sexOptionLabelNone'), value: null}
      },
      inputValues: {},
      subscriptionAside: false,
      formError: null,
      deleteError: null,
      modal: false
    }
  },
  computed:{
    hasMessage () {
      return !!this.inputValues.description
    }
  },
  mounted() {
    this.getCurrentData()
  },
  methods:{
    saveForm() {
      const { name, surname, email, phone, sex, state, city, description } = this.inputValues
      const picture = this.myProfileData.picture
      this.formError = null
      const values = Object.entries(this.inputValues).map((elem) => {
        let result = ''
        if(elem[0] === 'phone') {
          const value = elem[1].replace(/ /g, '')
          result += `${elem[0]}=${value}`
        } else if (elem[0] === 'name' || elem[0] === 'surname') {
          let val = elem[1]
          val = val[0].toUpperCase() + val.slice(1)
          this.inputValues[elem[0]] = val
          result += `${elem[0]}=${val}`
        } else if (elem[0] === 'birthday') {
          result += `birthday=${elem[1] ? Date.parse(new Date(elem[1])) / 1000 : ''}`
        } else {
          result += elem.join('=')
        }
        return result
      })
      this.$axios({
        method: 'post',
        url: '/api/v1/personnel/update/',
        data: values.join('&') + `&lang=${this.$i18n.locale || 'ru'}`
      })
      .then(({data}) => {
        if (data.error) {
          this.formError = data.error.message
        } else {
          this.$emit('editing', data.data)
        }
      })
      .catch(err => {
        console.log('ERROR', err)
      })
    },
    getCurrentData() {
      this.inputValues = {
        name: this.myProfileData.name || '',
        surname: this.myProfileData.surname || '',
        birthday: this.myProfileData.birthday ? new Date(Number(this.myProfileData.birthday) * 1000) : '',
        phone: this.myProfileData.phone || '',
        email: this.myProfileData.email || '',
        sex: this.myProfileData.sex || null,
        state: this.myProfileData.state || '',
        city: this.myProfileData.city || '',
        description: this.myProfileData.description || ''
      }
      switch(this.myProfileData.sex) {
        case ('Мужской' || 'Male'):
          this.dropdown.selected = {id: 1, name: this.$t('profileForm.sexOptionLabelMale'), value: 'M'}
          break
        case ('Женский' || 'Female'):
          this.dropdown.selected = {id: 1, name: this.$t('profileForm.sexOptionLabelFemale'), value: 'F'}
          break
        default:
          this.dropdown.selected = {id: 0, name: this.$t('profileForm.sexOptionLabelNone'), value: null}
          break
      }
    },
    deleteAccount() {
      this.deleteError = null
      this.$axios({
        method: 'post',
        url: '/api/v1/personnel/delete/'
      })
        .then(({data}) => {
          if (data.error) {
            this.deleteError = data.error.message
          } else {
            this.$cookies.remove('token')
            window.location.href = '/app'
          }
        })
        .catch(err => {
          console.log('ошибка при удалении аккаунта', err)
        })
    }
  }
}
